import React, { useState } from "react";
import "./projects.css";
import ProjectsData from "../data/projects.json";
import OptimizedImage from "./OptimizedImage";

export const Projects = () => {
  const [selectedProject, setSelectedProject] = useState(null);

  const openLightbox = (project) => {
    setSelectedProject(project);
  };

  const closeLightbox = () => {
    setSelectedProject(null);
  };

  return (
    <div id="projects" className="projects-section">
      <div className="projects-header">
          <div className="section-title">
          <h2>Past Projects</h2>
        </div>
      </div>

      <div className="projects-grid">
        {ProjectsData.projects.map((project) => (
          <div key={project.id} className="project-card">
            <div className="project-card-header">
              <h3>{project.name}</h3>
              <span className="project-category">{project.category}</span>
            </div>
            <p className="project-description">{project.description}</p>
            
            <div className="project-images-grid">
              {project.images.slice(0, 4).map((image, index) => (
                <OptimizedImage
                  key={index}
                  src={image}
                  alt={`${project.name} preview ${index + 1}`}
                  className="project-image"
                  onClick={() => openLightbox(project)}
                  width={300}
                  height={200}
                  placeholder={true}
                />
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Lightbox Modal */}
      {selectedProject && (
        <div className="lightbox-modal" onClick={closeLightbox}>
          <div className="lightbox-content">
            <button className="lightbox-close" onClick={closeLightbox}>
              &times;
            </button>
            <h2 className="lightbox-title">{selectedProject.name}</h2>
            <div className="lightbox-images-grid">
              {selectedProject.images.slice(0, 4).map((image, index) => (
                <OptimizedImage
                  key={index}
                  src={image}
                  alt={`${selectedProject.name} detailed view ${index + 1}`}
                  className="lightbox-image"
                  width={400}
                  height={300}
                  placeholder={true}
                />
              ))}
            </div>
            <p className="lightbox-description">{selectedProject.description}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Projects;
